import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: {
    marginLeft: 16
  },
  header: {
    width: 140,
    height: 33,
    paddingLeft: 6,
    paddingRight: 6,
    borderRadius: 3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around'
  },
  downArrowIconRight: {
    transition: `transform 0.2s`,
    transform: 'rotate(-90deg)'
  },
  downArrowIconCollapsed: {
    transform: 'rotate(0deg)'
  }
}))

export default useStyles
